export default __webpack_public_path__ + "static/media/default-card-image.c7342777.jpg";